import React, { useState, useEffect } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import KenSelect from '../../../global_components/KenSelect';
import { useHistory, useLocation } from 'react-router-dom';
import {
  getAcademicFilter,
  getDataForCourseEnrolment,
} from '../../../Utils/apiServices';

const useStyles = makeStyles((theme) => ({
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
}));
const ProgramFilters = (props) => {
  const { handleFilter, setLoading, programName, programPlanID } = props;
  const userDetails = localStorage.getItem('userDetails');
  const [courseOptions, setCourseOptions] = React.useState([]);
  const [programPlanIDOptions, setProgramPlanIDOptions] = useState([]);
  const [programID, setProgramID] = useState('');
  const classes = useStyles();
  const history = useHistory();

  React.useEffect(() => {
    setLoading(true);
    let programIDProp = history?.location?.state?.id || programID;
    setProgramID(programIDProp);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            label: item,
            value: item,
            id: keyVal?.id,
            terms: JSON.parse(keyVal.terms),
          });
        });
        setCourseOptions(courseOptions);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  React.useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    if (programID != '') {
      getDataForCourseEnrolment(instituteId)
        .then((res) => {
          let programPlanData = Object.entries(
            res?.ProgramPlanForEachAcedemicProgram
          ).filter((item) => {
            if (item[0] === programID) {
              return item;
            }
          });
          if (programPlanData.length > 0) {
            let programPlanIDOptions = [];
            programPlanData[0][1].map((items) => {
              programPlanIDOptions.push({
                label: items.ProgramPlanName,
                value: items.ProgramPlanId,
              });
            });
            setProgramPlanIDOptions(programPlanIDOptions);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [programID]);

  return (
    <Box mt={2} mb={2} className={classes.sortingSection}>
      <KenSelect
        name="courseName"
        label="Academic Program *"
        options={courseOptions}
        value={programName}
        dropdownColor="#ffffff"
        onChange={(el) => handleFilter(el, courseOptions)}
        required={true}
      />
      <KenSelect
        name="ProgramPlan"
        label="Program Plan *"
        options={programPlanIDOptions}
        value={programPlanID}
        dropdownColor="#ffffff"
        onChange={(el) => handleFilter(el, programPlanIDOptions)}
        required={true}
      />
    </Box>
  );
};

export default ProgramFilters;
